module.exports = __webpack_public_path__ + "static/media/teaser.b8d6f615.jpg";